export const keyCodeMapping = {
	// generate alphabet keys from KeyA: 'a' to KeyZ: 'z'
	...[...Array(26)].reduce((acc, _, index) => {
		const letter = String.fromCharCode(97 + index)
		acc[`Key${letter.toUpperCase()}`] = letter
		return acc
	}, {}),
	// generate number keys from Digit0: '0' to Digit9: '9'
	...[...Array(10)].reduce((acc, _, index) => {
		acc[`Digit${index}`] = String(index)
		return acc
	}, {}),
	// generate number keys from Numpad0: '0' to Numpad9: '9'
	...[...Array(10)].reduce((acc, _, index) => {
		acc[`Numpad${index}`] = String(index)
		return acc
	}, {}),
	// generate F1 to F12 and spread
	...[...Array(12)].reduce((acc, _, index) => {
		acc[`F${index + 1}`] = `F${index + 1}`
		return acc
	}, {}),
	// other special keys
	Backspace: 'Backspace',
	Tab: 'Tab',
	Enter: 'Enter',
	ShiftLeft: 'Shift',
	ShiftRight: 'Shift',
	ControlLeft: 'Control',
	ControlRight: 'Control',
	AltLeft: 'Alt',
	AltRight: 'Alt',
	MetaLeft: 'Meta',
	MetaRight: 'Meta',
	CapsLock: 'CapsLock',
	Escape: 'Escape',
	Space: ' ',
	PageUp: 'PageUp',
	PageDown: 'PageDown',
	End: 'End',
	Home: 'Home',
	Insert: 'Insert',
	Delete: 'Delete',
	ContextMenu: 'ContextMenu',
	NumLock: 'NumLock',
	ScrollLock: 'ScrollLock',
	AudioVolumeMute: 'AudioVolumeMute',
	AudioVolumeDown: 'AudioVolumeDown',
	AudioVolumeUp: 'AudioVolumeUp',
	MediaTrackNext: 'MediaTrackNext',
	MediaTrackPrevious: 'MediaTrackPrevious',
	MediaStop: 'MediaStop',
	MediaPlayPause: 'MediaPlayPause',
	LaunchMail: 'LaunchMail',
	LaunchMediaSelect: 'LaunchMediaSelect',
	LaunchApp1: 'LaunchApp1',
	LaunchApp2: 'LaunchApp2',
	Semicolon: ';',
	Equal: '=',
	Comma: ',',
	Minus: '-',
	Period: '.',
	Slash: '/',
	Backquote: '`',
	BracketLeft: '[',
	Backslash: '\\',
	BracketRight: ']',
	Quote: "'",
	IntlBackslash: '\\',
	Unidentified: '?',
	Alt: 'Alt',
	AltGraph: 'AltGraph',
	Control: 'Ctrl',
	Fn: 'Fn',
	FnLock: 'FnLock',
	Hyper: 'Hyper',
	Meta: 'Meta',
	Pause: 'Pause',
	Shift: 'Shift',
	Super: 'Super',
	Symbol: 'Symbol',
	SymbolLock: 'SymbolLock',
	ArrowDown: '↓',
	ArrowLeft: '←',
	ArrowRight: '→',
	ArrowUp: '↑',
	Paste: 'Paste',
	PrintScreen: 'PrintScreen',
	LaunchMediaPlayer: 'LaunchMediaPlayer',
	LaunchApplication1: 'LaunchApplication1',
	LaunchApplication2: 'LaunchApplication2',
	// custom bird
	hidden: '·',
}
